import { GetAvailableTemplateLanguagesParams } from '../config';

export const getAvailableTemplateLanguages = ({
  schemas,
  templates,
}: GetAvailableTemplateLanguagesParams): string[] =>
  Array.from(
    new Set(
      [
        ...templates
          .filter((template) => template.status !== 'archived')
          .map((template) => template.language),
        ...schemas.map((schema) => schema.language),
      ]
        .filter((language): language is string => Boolean(language))
        .map((language) => language.toLowerCase()),
    ),
  ).sort();
